export interface AppQuery {
  id?: string;
  item?: string;
  shopLocale?: string;
  market?: string;
  themeId?: string;
  firstSettingId?: string;
  appEmbedUuid?: string;
  highlight?: string;
}

export function getQueryFromSearch(search: string): AppQuery {
  const query = search
    .substring(1)
    .split('&')
    .reduce<{
      [key: string]: string;
    }>((items, item) => {
      const [key, value] = item.split('=');

      if (!value) {
        return items;
      }

      if (
        ![
          'id',
          'item',
          'shopLocale',
          'market',
          'themeId',
          'firstSettingId',
          'appEmbedUuid',
          'highlight',
        ].includes(key)
      ) {
        return items;
      }

      return {
        ...items,
        [key]: value,
      };
    }, {});

  return query as AppQuery;
}

export function getSearchFromQuery(query: AppQuery): string {
  return `?${Object.entries(query)
    .filter(([, value]) => Boolean(value), {})
    .map(([key, value]) => `${key}=${value}`)
    .join('&')}`;
}
